import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

interface RecordJson {
    token: string;
}

export const uploadConvertData = (json: RecordJson): any =>
    http.httpPost({
        url: httpApi.sw.uploadConvertData,
        json,
    });
